<script>
import General from '@/services/General';

export default {
  props:["popupId","popupName"],
  data() {
    return {
     chartData:[],
     chartLabels:[],
     stats:[],
     showModal: false,
     loadedChartData:false,
     totalOpenEvents:'',
     marketingPopUpStatisticsChartOptions: {
        chart: {
          width: "100%",
          height: 320,
          parentHeightOffset: 0,
          type: "bar",
          stacked: false,
          toolbar: {
            show: false,
          },
        },
        noData: {
          text: 'No data available',
          align: 'center',
          verticalAlign: 'middle',
          style: {
            color: '#6c757d',
            fontSize: '16px',
          },
        },
        stroke: {
          width: [1, 5],
          curve: "smooth",
        },
        plotOptions: {
          bar: {
            columnWidth: "50%",
          },
        },
        dataLabels: {
          enabled: false,
        },
        fill: {
          opacity: [0.85, 1],
          gradient: {
            inverseColors: false,
            shade: "light",
            type: "vertical",
            opacityFrom: 0.85,
            opacityTo: 0.55,
            stops: [0, 100, 100, 100],
          },
        },
        colors: ["#5b73e8", "#f1b54d"],
        markers: {
          size: 0,
        },
        xaxis: {
          labels: {
            style: {
              fontSize: '10px',
              fontFamily: 'Helvetica, Arial, sans-serif',
              fontWeight: 400,
              cssClass: 'apexcharts-xaxis-label',
            }
          },
          type: "text",
        },
        yaxis: {
          title: {
            text: "",
          },
        },
        tooltip: {
          shared: true,
          intersect: false,
          y: {
            formatter: function (y) {
              if (typeof y !== "undefined") {
                return y.toFixed(0) + "";
              }
              return y;
            },
          },
        },
      },
    };
  },
  methods: {
   
     async getMarketingPopupStatistics(){
      try{
        this.loadedChartData = true
        const filter = 'popupType=marketing&state=open&day=true';
        const response = await General.getHypePopUpStatistics(this.popupId,filter)
        this.stats = response.data.statistics;
        this.totalOpenEvents = this.stats.totalEvents

        this.chartData = [
          {
            name: 'Open Events',
            data: this.stats.data, // must be an array of numbers
          }
        ];

        this.marketingPopUpStatisticsChartOptions = {
          ...this.marketingPopUpStatisticsChartOptions,
          labels:response.data.statistics.labels
        }
        this.loadedChartData = false
      }catch(error){
        console.log(error)
        this.loadedChartData = false
      } finally {
        this.loadedChartData = false;
      }
    },

    closeModal() {
      this.showModal = false;
    },
   
  
  },
};
</script>

<template>
  <b-modal
    id="see_hype_popup_statistics"
    size="lg"
    v-model="showModal"
    @shown="getMarketingPopupStatistics"
    @hidden="closeModal"
    :title="`Marketing PopUp Statistics - ${this.popupName}`"
    centered
  >

  <div class="col-12">
      <div class=" h-75">
        <div v-if="!loadedChartData">
          <span  class="h5 ms-3 d-block d-md-inline">Marketing PopUp Open Events: {{ totalOpenEvents }}</span>
          <div class="col-sm-4 float-end p-0">
            <!-- <select v-model="graph_type_users" class="form-select" @change="getCustomerDevicesStatistics()"
              style="padding-right: 2rem;">
              <option value="daily" selected>Daily</option>
              <option value="monthly">Monthly</option>
            </select> -->
          </div>
          <br />

          <apexchart
                      id="marketingPopUpStatisticsChart"
                      data-colors='["--bs-primary", "#dfe2e6"]'
                      class="apex-charts"
                      ref="usersChart"
                      :options="marketingPopUpStatisticsChartOptions"
                      :series="chartData"
          >
          </apexchart>
          <!-- <div v-else class=" d-flex gap-2 justify-content-center align-items-center flex-column">
                <i class="uil-folder-slash text-info" style="font-size:100px"></i>
                <p style="text-align: center; margin-top: -20px; font-weight: bold;">No data available</p>
          </div>
         -->
        </div>
        <div class="col-12 mt-5 d-flex align-items-center justify-content-center" v-else>
          <b-spinner large></b-spinner>
        </div>
      </div>
    </div>
 
    <template v-slot:modal-footer>
      <b-button variant="light" @click="closeModal">Close</b-button>
    </template>
  </b-modal>
</template>

